module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"caption":"CRESPO APP SUBSCRIPTION","title":"Ready-made sports app from","price":" $700 per month","action":"Request a Price list"},"ru":{"caption":"ПОДПИСКА CRESPO APP","title":"Готовое спортивное приложение от ","price":"$700 / месяц","action":"Запросить Прайс-лист"}}')
  delete Component.options._Ctor
}
